<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column cabinet__tbody-column--number">
      {{ number }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--publication-date">
      {{ publicationDate }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--application-deadline">
      {{ applicationDeadline }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--purchase-name wk__textarea">
      {{ objectName }}
      <div v-if="isAdmin && managerFullName">
        <br>Отв.: <b>{{ managerFullName }}</b>
      </div>
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--delivery-region wk__textarea">
      {{ region }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--nmc thead-th--rigth">
      {{ startCost }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--status wk__textarea">
      {{ status }}
      <div
        class="cabinet__tbody-row__count-offer"
        :class="{'cabinet__tbody-row__count-offer--hover': offerCountItems.length}"
        @click="offerCountItems.length ? isOpenPopup = true: false"
      >
        {{ offerCount }}
      </div>
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--tooltip">
      <PurchasesTableTooltip :item="item" />
    </td>
  </tr>

  <Popup
    v-model:value="isOpenPopup"
    title="Предложения участников"
    css-class="purchase-modal-items"
  >
    <div class="purchase-modal-items__list">
      <div class="purchase-modal-items__list-item">
        <div class="purchase-modal-items__list-item__label">
          Подано:
        </div>
        <div class="purchase-modal-items__list-item__value">
          {{ offerCount }}
        </div>
      </div>
      <div
        v-for="(supplierName,index) in offerCountItems"
        :key="supplierName"
        class="purchase-modal-items__list-item"
      >
        <div class="purchase-modal-items__list-item__label">
          Поставщик {{ index + 1 }}:
        </div>
        <div class="purchase-modal-items__list-item__value">
          {{ supplierName }}
        </div>
      </div>

      <button
        class="search__button purchase-modal-items__btn"
        @click="isOpenPopup = false"
      >
        <span class="search__link">Закрыть</span>
      </button>
    </div>
  </Popup>
</template>

<script>
import { formatterToRub } from '@/utils/helpers';
import PurchasesTableTooltip from '@/components/elements/PurchasesTableTooltip.vue';
import dayjs from 'dayjs';
import Popup from '@/components/popup/popup.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'PurchaseTableItem',
  components: {
    PurchasesTableTooltip,
    Popup,
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isOpenPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      hasRole: 'user/hasRole',
    }),
    number() {
      return this.item.documentNumber ?? '';
    },
    publicationDate() {
      return this.item.activeFrom ? dayjs(this.item.activeFrom)
        .format('DD.MM.YYYY') : '';
    },
    applicationDeadline() {
      return this.item.activeTo ? dayjs(this.item.activeTo)
        .format('DD.MM.YYYY HH:MM') : '';
    },
    region() {
      return this.item.objectRegion?.join(', ') || '';
    },
    objectName() {
      return this.item.name;
    },
    status() {
      return this.item.status || '';
    },
    offerCount() {
      return this.item.offer?.count || '';
    },
    offerCountItems() {
      return this.item.offer?.suppliers || [];
    },
    startCost() {
      return formatterToRub(this.item.startCost) || 'НМЦ не определена';
    },
    managerFullName() {
      return this.item?.managerFullName || '';
    },
    isAdmin() {
      return this.hasRole('administrator');
    },
  },
  methods: {
    goToAuth() {
      this.$router.push({
        name: 'Auth',
        query: { from: window.location.pathname },
      });
    },
    formatterToRub(value) {
      if (!value) {
        return false;
      }
      const formatter = new Intl.NumberFormat('ru', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        currencyDisplay: 'code',
      });
      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss">
.cabinet__tbody-row__count-offer {
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.01em;
  color: #808388;
  margin-top: 2px;

  &--hover {
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #161C21;
    text-decoration: underline;

    &:hover {
      cursor: pointer;
      text-decoration: none;
      color: #77A730;
    }
  }
}

.purchase-modal-items {
  width: 100%;
  max-width: 920px;

  &__list {
    &-item {
      display: grid;
      grid-template-columns: 140px 1fr;
      grid-column-gap: 30px;

      &__label {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #161C21;
      }

      &__value {
        font-weight: 600;
        font-size: 18px;
        line-height: 140%;
        letter-spacing: 0.01em;
        color: #161C21;
      }
    }

    &-item + &-item {
      margin-top: 16px;
    }
  }

  &__btn {
    width: 250px;
    margin: 40px auto 0;
  }
}
</style>
